import { useEffect, useRef, useState } from 'react';
import { FaRegCircleXmark } from 'react-icons/fa6';
import style from '../../../Styles/TimeSheet.module.css';
import {
  Button,
  DatePicker,
  Divider,
  Dropdown,
  Form,
  Radio,
  Popover,
} from 'antd';
import { IoIosSwitch, IoMdInformationCircleOutline } from 'react-icons/io';
import { TimePicker, Input, Select } from 'antd';
import { Table } from 'reactstrap';
import {
  CloseOutlined,
  PlusOutlined,
  ReadOutlined,
  CheckCircleFilled,
  MoreOutlined,
} from '@ant-design/icons';
import dayjs from 'dayjs';
import isBetween from 'dayjs/plugin/isBetween';
import {
  toastError,
  toastInfo,
  toastSuccess,
  toastWarn,
} from '../../Toast/ToastComponent';
import { TimeSheetApi } from '../../../Api/TimeSheetApi';
import { useAuth } from '../../../Context/AuthContext';
import {
  CONFIRMATIONFULLDAY,
  CONFIRMATIONHOLIDAY,
  CONFIRMATIONWEEKEND,
  DateFormat,
  DisplayDateFormat,
  LEAVETYPE,
  TASK_BREAK_FEILDS,
  TASK_PERMISSIONS,
} from '../../../constant/constant';
import { ReactSortable } from 'react-sortablejs';
import { RxDragHandleDots2 } from 'react-icons/rx';
import {
  dateFormatToDayjs,
  dateFormatToHHmm,
  dayjsToDateFormat,
  formatToTodayDate,
  getMonthFromDate,
  getYearFromDate,
} from '../../../ReusableFn/reusableFn';
import Mandatory from '../../ReusableComponents/Mandatory';
import { confirmationPopup } from '../../ReusableComponents/DeletePopup';
import { LuCalendarClock } from 'react-icons/lu';
import { ignore } from 'antd/es/theme/useToken';
import { useNavigate } from 'react-router-dom';

const { Option } = Select;

dayjs.extend(isBetween);
const items = [
  {
    key: '1',
    label: (
      <div>
        <b>Conversion Time Formats</b>
      </div>
    ),
  },
  {
    key: '2',
    label: (
      <div>
        <span>
          <b>0.25</b> - Fifteen minutes
        </span>{' '}
        <br />
        <span>
          <b>0.50</b> - Thirty minutes
        </span>{' '}
        <br />
        <span>
          <b>0.75</b> - Forty five minutes
        </span>{' '}
        <br />
        <span>
          <b>1.00</b> - One hour
        </span>{' '}
        <br />
        <span>
          <b>2.50</b> - Two hours Thirty minutes
        </span>{' '}
        <br />
        <span>
          <b>4.75</b> - Four hours and forty five minutes
        </span>{' '}
        <br />
      </div>
    ),
  },
  {
    key: '3',
    label: (
      <div>
        <b>
          <Mandatory /> (Permission, Others & Leave) will not be added in total
          hrs
        </b>
      </div>
    ),
  },
];
const ONE_BY_SIXTY = 0.0166666666666667;
const { TextArea } = Input;
const columns = [
  { feildname: '', className: 'col-auto', headerName: '' },
  {
    feildname: 'project_id',
    className: 'col-auto',
    headerName: 'Project Name',
    required: true,
  },
  {
    feildname: 'module_id',
    className: 'col-3',
    headerName: 'Module',
    required: true,
  },

  { feildname: 'task', className: 'col-3', headerName: 'Task', required: true },
  {
    feildname: 'time_spent',
    className: 'col-3',
    headerName: 'Time Spent',
    required: true,
  },
  {
    feildname: 'individual_hours',
    className: 'col-1',
    headerName: '',
    required: false,
  },
  { feildname: 'Action', className: 'col-1', headerName: '', required: false },
];

const FULL_DAY = 'fullDay';
const HALF_DAY = 'halfDay';

const OPTIONS_ARR = [[], TASK_BREAK_FEILDS, TASK_PERMISSIONS, LEAVETYPE];

const TASK_FEILDS = [1, 2, 3];

const SET_START_TIME = [
  dayjs().set('hour', 9).set('minute', 30).set('second', 0),
  dayjs().set('hour', 10).set('minute', 30).set('second', 0),
];
const CROSSED_TIME = dayjs()
  .set('hour', 23)
  .set('minute', 59)
  .set('second', 30);
const LEAVE_DURATION = [
  { value: 'halfDay', label: 'Half Day' },
  { value: 'fullDay', label: 'Full Day' },
];

const CTRL_CONST = {
  isDeactivated: false,
  task_type: false,
  customModule: false,
  LeaveType: false,
};

const AddLogBdyDnD = ({ toggleModal, isEdit }) => {
  const navigate = useNavigate();
  const check = useRef(null);

  const [assignPermission, setAssignedPermission] = useState({
    isApplied: false,
    index: 0,
    timing: [],
    log: {},
  });
  const logObj = {
    project_id: null,
    project_name: null,
    module_id: null,
    module_name: null,
    task: null,
    leave_duration: null,
    billable: false,
    time_spent: SET_START_TIME,
    type: 'working',
    consider_bill: 'bill',
    individual_hours: 1,
  };
  const [log, setLog] = useState([{ ...logObj }]);

  const initialValues = {
    date: dayjs(),
    timesheet_data: log,
    total_hours: 1,
    type: 'working',
    isBillable: false,
  };

  const [feildValue, setFeildValue] = useState({
    project: [],
    module: [[]],
    taskFeild: [],
  });
  // primaryModuleMap: { [project_id]: module_id } — tracks which module is primary per project
  const [primaryModuleMap, setPrimaryModuleMap] = useState({});
  // popoverVisible: { [rowIndex_moduleValue]: bool }
  const [popoverVisible, setPopoverVisible] = useState({});
  // moduleSelectOpen (state): drives the controlled `open` prop on each row's Select
  const [moduleSelectOpen, setModuleSelectOpen] = useState({});
  // moduleSelectForceOpen (ref): written SYNCHRONOUSLY in the three-dot onMouseDown so
  // that onDropdownVisibleChange can read it before any React re-render happens.
  const moduleSelectForceOpen = useRef({});
  const [feildCtrl, setFeildCtrl] = useState([CTRL_CONST]);
  const { authState } = useAuth();
  const [form] = Form.useForm();

  let [timesheetDetails, setTimesheetDetails] = useState({
    project: [],
    modules: [],
  });

  const watchType = Form.useWatch('type', form);

  const watchRef = useRef('working');

  useEffect(() => {
    getProjectDropDown().then((data) => {
      if (data && isEdit?.edit === false) getAppliedPermissionData();
    });
    if (isEdit?.edit === true) {
      getEditLogData(isEdit?.id);
    }
    return () => {
      setFeildValue({
        project: [],
        module: [[]],
        taskFeild: [],
      });
      setFeildCtrl([{ ...CTRL_CONST }]);
      setLog([
        {
          project_id: null,
          project_name: null,
          module_id: null,
          module_name: null,
          task: null,
          billable: false,
          time_spent: [],
          individual_hours: null,
        },
      ]);
    };
  }, [isEdit]);

  const permissionController = (permissionData) => {
    const convertToSelectedDate = getFormFeilds('date');
    if (!!permissionData) {
      const { time, timeSheetData, type } = permissionData;
      // Guard: timeSheetData may be absent when the API returns a result
      // object without an active permission entry.
      if (!timeSheetData || !timeSheetData['time_spent']) {
        setAssignedPermission((pre) => ({
          ...pre,
          isApplied: false,
          log: {},
        }));
        return;
      }
      const time_spent = [
        formatToTodayDate(
          convertToSelectedDate,
          dayjs(timeSheetData['time_spent'][0]),
        ),
        formatToTodayDate(
          convertToSelectedDate,
          dayjs(timeSheetData['time_spent'][1]),
        ),
      ];
      setAssignedPermission((pre) => ({
        ...pre,
        isApplied: true,
        timing: time,
        log: { ...timeSheetData, time_spent: time_spent },
      }));
      verifyCollision(timeSheetData['time_spent']);
    } else {
      setAssignedPermission((pre) => ({
        ...pre,
        isApplied: false,
        log: {},
      }));
    }
  };

  //debounce for toast msg

  const outerFn = (() => {
    let outData;
    return function innerFn() {
      clearTimeout(outData);
      outData = setTimeout(() => {
        toastInfo(
          'Some time stamp has been removed as it is in the middle of the permission timing',
        );
      }, 600);
    };
  })();

  const verifyCollision = (permissionTime) => {
    const timeSpent = getFormFeilds('timesheet_data') || [];
    if (timeSpent.length > 0) {
      timeSpent.forEach((element, index) => {
        if (findBetweenTime(element?.time_spent, permissionTime, index)) {
          setFormListFeilds(index, 'time_spent', []);
          setFormListFeilds(index, 'individual_hours', null);
          outerFn();
        }
      });
      sumUpTotalHrs();
    }
  };

  const findBetweenTime = (timeSpent, permissionTime = [], index) => {
    let permissionTiming = permissionTime || [];
    if (permissionTiming.length !== 2) return false;
    const convertToSelectedDate = getFormFeilds('date');

    permissionTiming = [
      formatToTodayDate(convertToSelectedDate, permissionTiming[0]),
      formatToTodayDate(convertToSelectedDate, permissionTiming[1]),
    ];
    timeSpent = [
      formatToTodayDate(convertToSelectedDate, timeSpent[0]),
      formatToTodayDate(convertToSelectedDate, timeSpent[1]),
    ];
    // console.log('permissionTiming,timeSpent', permissionTiming, timeSpent);
    const newChecked = timeSpent.map((item) => {
      const checkTime = dayjs(item);
      const data = checkTime.isBetween(
        permissionTiming[0],
        permissionTiming[1],
      );
      return data;
    });

    const permissionTimeOne = Math.round(permissionTiming[0].valueOf() / 1000); //-- 9:30 am
    const permissionTimeTwo = Math.round(permissionTiming[1].valueOf() / 1000); //-- 11:30 am
    const timeSpentOne = Math.round(timeSpent[0].valueOf() / 1000); //-- 9:30 am
    const timeSpentTwo = Math.round(timeSpent[1].valueOf() / 1000); //-- 11:30 am
    let DoesItsFallsBtw = false;
    if (
      permissionTimeOne >= timeSpentOne &&
      permissionTimeOne <= timeSpentTwo &&
      permissionTimeTwo >= timeSpentOne &&
      permissionTimeTwo <= timeSpentTwo
    ) {
      DoesItsFallsBtw = true;
    }

    return Boolean(newChecked[0]) || Boolean(newChecked[1]) || DoesItsFallsBtw;
  };

  const getAppliedPermissionData = async () => {
    const checkDate = form.getFieldsValue() || {};
    const reqData = {
      user_id: authState.id,
      date: dayjsToDateFormat(checkDate?.date),
    };
    return new Promise((resolve, reject) => {
      TimeSheetApi.checkAppliedPermission(reqData).then((response) => {
        if (response.data.success) {
          permissionController(response.data.result);
          resolve(response.data);
        } else {
          toastError(response?.data?.message);
          reject(new Error(response.data.message));
        }
      });
    }).catch((err) => {
      console.log(err);
      toastError(err?.response?.data?.message);
    });
  };

  const getEditLogData = async (id) => {
    try {
      const response = await TimeSheetApi.getLogData(id);
      const res = response?.data;
      if (res?.success) {
        if (res?.result?.length > 0) {
          setFeildsLog(res?.result[0]);
        } else {
          form.setFieldsValue(initialValues);
        }
      } else {
        toastError(response?.data?.message);
      }
    } catch (error) {
      //toastError(error.response.data.message);
      toastError(error);
    }
  };

  const setFeildsLog = async (logData) => {
    let setData = {
      date: dateFormatToDayjs(logData?.date),
      type: logData?.type === 'semiWorking' ? 'working' : logData?.type,
      total_hours: logData?.total_hours,
      timesheet_data: [],
    };

    if (
      logData?.timesheet_data?.length > 0 &&
      (setData?.type === 'working' || setData?.type === 'leave')
    ) {
      let moduleCall = [];
      let feildCtrls = [];

      const convertToSelectedDate = getFormFeilds('date');
      let updatedLog = logData?.timesheet_data.map((item, index) => {
        moduleCall.push(callModuleDropDown(item.project_id));
        feildCtrls.push(manageFeildCtrls(item));
        handleTaskFeild(index, item?.module_id);
        const timeDayLog = item.time_spent.map((dayItm) =>
          formatToTodayDate(convertToSelectedDate, dayjs(dayItm)),
        );
        return { ...item, time_spent: timeDayLog };
      });
      Promise.all([...moduleCall])
        .then((resArr) => {
          setFeildValue((pre) => ({ ...pre, module: resArr }));
          setFeildCtrl(feildCtrls);
          setData['timesheet_data'] = updatedLog;
          form.setFieldsValue(setData);
          disableProject(TASK_FEILDS[2]);
          getAppliedPermissionData();
        })
        .catch((err) => console.log(err));
    } else {
      await resetLogData(logData);
      form.setFieldsValue({ date: dayjs(logData?.date) });
    }
  };

  const setFormListFeilds = (index, name, value = null) => {
    form.setFieldValue(['timesheet_data', index, name], value);
  };
  const setFormFeilds = (name, value = null) => {
    form.setFieldValue(name, value);
  };
  const getFormListFeilds = (index, name) => {
    return form.getFieldValue(['timesheet_data', index, name]);
  };
  const getFormFeilds = (name) => {
    return form.getFieldValue(name);
  };

  const getProjectDropDown = async () => {
    let reqData = {
      id: authState?.id,
      userRoleID: authState?.userRoleID,
      ...(isEdit?.id && isEdit?.id != -1 ? { omitId: isEdit?.id } : {}),
    };

    try {
      const response = await TimeSheetApi.getProjectDropDown(reqData);
      if (response?.data?.success) {
        const res = response?.data?.result || [];
        const setProjectDisables = res.map((item) => ({
          ...item,
          disabled: false,
        }));
        check.current = [...setProjectDisables];
        setFeildValue((pre) => ({ ...pre, project: [...setProjectDisables] }));
        return setProjectDisables;
      } else {
        toastError(response?.data?.message);
      }
    } catch (error) {
      //toastError(error.response.data.message);
      toastError(error);
    }
  };

  const callModuleDropDown = (projectId) => {
    let reqData = {
      id: authState?.id,
      project_id: projectId,
      userRoleID: authState?.userRoleID,
      ...(isEdit?.id && isEdit?.id != -1 ? { omitId: isEdit?.id } : {}),
    };
    // let formTreeData = [];
    return new Promise((resolve, reject) => {
      TimeSheetApi.getModuleDropDown(reqData)
        .then((response) => {
          if (response?.data?.success) {
            const newResObj = response?.data?.result || [];
            resolve(newResObj);
          } else {
            reject(new Error(response.data.message));
          }
        })
        .catch((messgae) => console.log(messgae));
    });
  };

  // Call API to set a module as primary for a project
  const handleSetPrimary = async (projectId, moduleId, rowIndex) => {
    try {
      const reqData = {
        user_id: authState?.id,
        project_id: projectId,
        module_id: moduleId,
      };
      const response = await TimeSheetApi.setPrimaryModule(reqData);
      if (response?.data?.success) {
        toastSuccess('Primary module set successfully');
        // Update the primary flag directly inside feildValue.module so the
        // green-tick renders immediately on next paint — across every row that
        // shows modules for this project.
        setFeildValue((prev) => {
          const newModule = prev.module.map((rowModules) => {
            if (!rowModules || rowModules.length === 0) return rowModules;
            // Only touch rows whose module list belongs to this project
            const belongsToProject = rowModules.some(
              (m) => m.project_id === projectId,
            );
            if (!belongsToProject) return rowModules;
            return rowModules.map((m) => ({
              ...m,
              primary: m.value === moduleId,
            }));
          });
          return { ...prev, module: newModule };
        });
        // Auto-pick the chosen primary module in the module_id field for this row
        setFormListFeilds(rowIndex, 'module_id', moduleId);
      } else {
        toastError(response?.data?.message);
      }
    } catch (error) {
      toastError(
        error?.response?.data?.message || 'Failed to set default module',
      );
    } finally {
      // Close the three-dot popup and release the force-open lock
      setPopoverVisible({});
      moduleSelectForceOpen.current[rowIndex] = false;
      setModuleSelectOpen((prev) => {
        const updated = { ...prev };
        delete updated[rowIndex]; // ✅ exact fix
        return updated;
      });
    }
  };

  const getModuleDropDown = async (projectId, index) => {
    callModuleDropDown(projectId)
      .then((resArr) => {
        let newModuleObj = [...feildValue.module];
        newModuleObj[index] = resArr;
        setFeildValue((pre) => ({
          ...pre,
          module: newModuleObj,
        }));
        let newCtrlField = feildCtrl;
        newCtrlField[index] = CTRL_CONST;
        setFormListFeilds(index, 'module_name');
        setFormListFeilds(index, 'module_id');
        setFeildCtrl([...newCtrlField]);

        let callTotalTimeSpent =
          Boolean(getFormListFeilds(index, 'time_spent')[0]) &&
          Boolean(getFormListFeilds(index, 'time_spent')[1]);
        if (projectId === 2 || projectId === 3) {
          setFormListFeilds(index, 'consider_bill', 'nonbill');
        } else {
          setFormListFeilds(index, 'consider_bill', 'bill');
        }
        disableProject(TASK_FEILDS[2]);

        if (callTotalTimeSpent) {
          sumUpTotalHrs();
        }
        setFormListFeilds(index, 'task');
        handleTaskFeild(index);

        // Auto-select primary module if one exists for this project
        const primaryMod = resArr.find((m) => m.primary === true);
        if (primaryMod) {
          // Small delay so the field is rendered
          setTimeout(() => {
            setFormListFeilds(index, 'module_id', primaryMod.value);
            handleTaskFeild(index, 0, primaryMod);
          }, 0);
        } else {
          setFormListFeilds(index, 'module_id');
        }
      })
      .catch((msg) => console.log(msg));
  };

  const convertTimeToOne = (timespentArr) => {
    if (timespentArr?.length == 0) return 0;
    let milliSec =
      dayjs(timespentArr[1]).valueOf() - dayjs(timespentArr[0]).valueOf();
    let calMints = milliSec / (1000 * 60);
    let mintsToRound =
      calMints * ONE_BY_SIXTY > 0 ? calMints * ONE_BY_SIXTY : 0;
    return mintsToRound || 0;
  };

  const verifyEnteredHrs = (time_spent, indx) => {
    if (assignPermission.isApplied) {
      const inBetweenTime = findBetweenTime(
        time_spent,
        assignPermission.timing,
        indx,
      );
      if (inBetweenTime) {
        // crossedChosen(indx);
        return true;
      }
      return false;
    }
    return false;
  };

  const emptyCrossedTime = (index) => {
    toastWarn('Chosen time is within the Applied permission period');
    setFormListFeilds(index, 'time_spent', []);
    setFormListFeilds(index, 'individual_hours', null);
    sumUpTotalHrs();
  };

  const handleTimeSpent = async (timeSpent, index) => {
    // if (timeSpent === null || timeSpent.length <= 0) return;
    if (assignPermission.isApplied) {
      const checkedTime = findBetweenTime(
        timeSpent,
        assignPermission.timing,
        index,
      );
      if (checkedTime == true) {
        // toastWarn('Chosen time is within the Applied permission period');
        // setFormListFeilds(index, 'time_spent', []);
        // setFormListFeilds(index, 'individual_hours', null);
        // sumUpTotalHrs();
        emptyCrossedTime(index);
        return;
      }
    }

    const mintsToRound = convertTimeToOne(timeSpent);
    const formattedTimeSpent = formatNumber(mintsToRound) || 0;

    let timesheetData = form.getFieldValue('timesheet_data');

    let individualData = form.getFieldValue(['timesheet_data', index]);

    let moduleObject = feildValue?.module[index]?.filter(
      (element) => element?.value == individualData?.module_id,
    );

    let projectData = feildValue?.project?.filter(
      (element) => element?.value == individualData?.project_id,
    );

    var moduleHoursTaken = parseFloat(formattedTimeSpent) || 0.0;

    var projectHoursTaken = parseFloat(formattedTimeSpent) || 0.0;

    for (const element of timesheetData) {
      if (element?.module_id == individualData?.module_id) {
        moduleHoursTaken += parseFloat(element?.individual_hours) || 0.0;
      }
      if (element?.project_id == individualData?.project_id) {
        projectHoursTaken += parseFloat(element?.individual_hours) || 0.0;
      }
    }

    let condition = moduleObject[0]?.estimated_hours
      ? parseFloat(moduleHoursTaken) >
        parseFloat(moduleObject[0]?.remainingHours || 0)
      : false;

    if (condition == false && projectData[0]?.estimatedHours) {
      condition =
        parseFloat(projectHoursTaken) >
        parseFloat(projectData[0]?.remainingHours || 0);
    }

    if (condition && ![1, 2, 3, 4].includes(moduleObject[0]?.value)) {
      setFormListFeilds(index, 'time_spent', [
        individualData?.time_spent[0],
        null,
      ]);
      setFormListFeilds(index, 'individual_hours', null);
      toastInfo('The balance hours for this module have been completed.');
      return;
    }

    setFormListFeilds(index, 'individual_hours', formattedTimeSpent);

    sumUpTotalHrs();
  };

  const setOrientation = (date, time_spent_arr = []) => {
    let updatedTimeSpentArr = [];
    const getDayType = getFormFeilds('type');

    if (assignPermission.isApplied && getDayType == 'working') {
      updatedTimeSpentArr = [assignPermission.log, ...time_spent_arr];
    } else {
      updatedTimeSpentArr = [...time_spent_arr];
    }
    let sortExistingArr = updatedTimeSpentArr.sort((a, b) => {
      const one = Math.round(
        formatToTodayDate(date, a?.time_spent[0]).valueOf() / 1000,
      );
      const two = Math.round(
        formatToTodayDate(date, b?.time_spent[0]).valueOf() / 1000,
      );

      return one - two;
    });
    return sortExistingArr;
  };

  function formatNumber(mintsToRound) {
    const roundedNumber = Number(mintsToRound).toFixed(2);
    return roundedNumber.endsWith('.00')
      ? Math.floor(Number(roundedNumber))
      : roundedNumber;
  }

  const handleAdd = (add) => {
    if (watchType !== 'working') {
      toastInfo('Please mark it as ‘working’ to add a log.');
      return;
    }
    setFeildCtrl((pre) => [...pre, { ...CTRL_CONST }]);
    setFeildValue((pre) => ({ ...pre, module: [...pre.module, []] }));

    let newAdd = {
      project_id: null,
      project_name: null,
      module_id: null,
      module_name: null,
      task: null,
      leave_duration: null,
      billable: false, //used for ckecking and unchecking in approve and reject while approving timesheet
      time_spent: [],
      consider_bill: 'bill',
      individual_hours: null,
    };
    let timeSpent = getFormFeilds('timesheet_data') || [];
    if (timeSpent?.length === 0) {
      form.setFieldValue('timesheet_data', [newAdd]);
      return;
    }
    let lastLog = timeSpent[timeSpent.length - 1];
    if (lastLog['leave_duration'] === LEAVE_DURATION[1].value) {
      toastInfo('Please mark it as ‘working’ to add a log.');
      return;
    }

    form
      .validateFields()
      .then((values) => {
        if (!values?.errorFields?.length) {
          let lastEndTime = lastLog?.time_spent;
          newAdd['time_spent'] = !!lastEndTime[1] ? [lastEndTime[1], null] : [];
          form.setFieldValue('timesheet_data', [...timeSpent, newAdd]);
        }
      })
      .catch((error) => 0);

    return;
  };

  const changeLogType = (e, index) => {
    let timeSpent = getFormFeilds('timesheet_data') || [];
    let setLogType = e == FULL_DAY ? FULL_DAY : 'working';
    setFormFeilds('type', setLogType);
    if (setLogType == FULL_DAY) {
      let setLabel = confirmLabelSetter(setLogType) || {};
      confirmationPopup(async (canDelete) => {
        if (canDelete) {
          let resetFieldCtrl = feildCtrl[index] || {};
          let resetFeildValue = feildValue;
          let newFieldValue = {
            project: resetFeildValue.project || [],
            module: [resetFeildValue.module[index] || []],
            taskFeild: [resetFeildValue.taskFeild[index] || []],
          };
          setFeildCtrl([resetFieldCtrl]);
          setFeildValue({ ...newFieldValue });
          setFormFeilds('timesheet_data', [
            { ...timeSpent[index], time_spent: [], individual_hours: null },
          ]);
          sumUpTotalHrs();
        } else {
          setFormListFeilds(index, 'leave_duration');
          setFormFeilds('type', watchRef.current);
        }
      }, setLabel);
      return;
    } else {
    }
  };

  const disableProject = (id) => {
    let boolVal = false;
    let timesheet_data = form.getFieldValue('timesheet_data');
    let findLeaveInc;
    if (id == TASK_FEILDS[2]) {
      findLeaveInc = timesheet_data.find((item) => item?.project_id == id);
    } else if (id == TASK_FEILDS[1]) {
      findLeaveInc = true;
    }
    if (!!findLeaveInc) {
      boolVal = true;
    } else {
      boolVal = false;
    }
    let projectList = check.current || [];
    const newDisabledArr =
      projectList.map((item, idx) =>
        item.value == id ? { ...item, disabled: boolVal } : item,
      ) || [];
    setFeildValue((pre) => ({ ...pre, project: newDisabledArr }));
  };

  const calculateIndivHrs = (timeSpent_arr) => {
    return (
      timeSpent_arr.reduce(
        (accumulator, currentValue) =>
          accumulator + Number(currentValue.individual_hours),
        0,
      ) || 0
    );
  };

  const extractOnlyBillable = (arr) => {
    return arr.filter((item) => item.consider_bill === 'bill') || [];
  };

  const sumUpTotalHrs = () => {
    let timeSpent = getFormFeilds('timesheet_data') || [];
    let onlyBillable = extractOnlyBillable(timeSpent);
    let accTotal = 0;
    onlyBillable.forEach((item) => {
      if (Boolean(item?.time_spent[0]) && Boolean(item?.time_spent[1])) {
        let milliSec =
          dayjs(item?.time_spent[1]).valueOf() -
          dayjs(item?.time_spent[0]).valueOf();
        let calMints = milliSec / (1000 * 60);
        let mintsToRound =
          calMints * ONE_BY_SIXTY > 0 ? calMints * ONE_BY_SIXTY : 0;
        accTotal += mintsToRound;
      }
    });

    setFormFeilds('total_hours', Number(accTotal).toFixed(2));
  };

  const handleTaskFeild = async (indx, module_id = 0, value) => {
    let timesheetData = form.getFieldValue('timesheet_data');

    if (value) {
      let projectData = feildValue?.project?.filter(
        (element) => element?.value == value?.project_id,
      );

      var moduleHoursTaken = 0.0;

      var projectHoursTaken = 0.0;

      for (const element of timesheetData) {
        if (element?.module_id == value?.value) {
          moduleHoursTaken += parseFloat(element?.individual_hours) || 0.0;
        }
        if (element?.project_id == value?.project_id) {
          projectHoursTaken += parseFloat(element?.individual_hours) || 0.0;
        }
      }

      let condition = value?.estimated_hours
        ? parseFloat(moduleHoursTaken) > parseFloat(value?.remainingHours || 0)
        : false;

      if (condition == false && projectData[0]?.estimatedHours) {
        condition =
          parseFloat(projectHoursTaken) >
          parseFloat(projectData[0]?.remainingHours || 0);
      }

      if (condition && ![1, 2, 3, 4].includes(value?.value)) {
        setFormListFeilds(indx, 'module_id');
        setFormListFeilds(indx, 'module_name');
        setFormListFeilds(indx, 'task');
        toastInfo('The balance hours for this module has been exceeded.');
        return;
      }
    }

    let checkModule;
    if (isEdit.edit === true && module_id !== 0) {
      checkModule = module_id;
    } else if (module_id === 0) {
      checkModule =
        Number(form.getFieldValue(['timesheet_data', indx, 'module_id'])) || 0;
    }
    let newFeildCtrl;
    if (TASK_FEILDS.includes(checkModule)) {
      let LeaveType = checkModule == 3 ? true : false;
      newFeildCtrl = feildCtrl.map((item, idx) =>
        idx === indx
          ? {
              ...item,
              LeaveType,
              task_type: true,
            }
          : item,
      );
      let newArrTASK_FEILDS = feildValue.taskFeild || [];
      newArrTASK_FEILDS[indx] = OPTIONS_ARR[checkModule] || [];
      setFeildValue((pre) => ({ ...pre, taskFeild: [...newArrTASK_FEILDS] }));
    } else {
      newFeildCtrl = feildCtrl.map((item, idx) =>
        idx === indx ? { ...item, LeaveType: false, task_type: false } : item,
      );
    }
    setFeildCtrl(newFeildCtrl);
    setFormListFeilds(indx, 'task');
    setFormListFeilds(indx, 'leave_duration');
  };

  const onSubmit = async (data) => {
    if (authState.id == 1 || authState.id == 2) {
      toastInfo('Application Admin cannot create Timesheet.');
      return;
    }

    if (!data?.timesheet_data?.length) {
      toastInfo('Please add log to proceed.');
      return;
    }
    const month = getMonthFromDate(data.date.$d);
    const year = getYearFromDate(data.date.$d);

    if (assignPermission.isApplied) {
      data['permission_id'] = assignPermission?.log?.permissionID;
    }
    let findLeave =
      data?.timesheet_data.find((item) => item?.project_id === 3) || {};

    data?.timesheet_data?.map((item, indx) => {
      item['task_type'] = feildCtrl[indx]?.task_type || false;
      item['customModule'] = feildCtrl[indx]?.customModule || false;
      item['LeaveType'] = feildCtrl[indx]?.LeaveType || false;
      return item;
    });
    let cal = calculatebillable(data?.timesheet_data) || {};
    let sortedArr = setOrientation(data?.date, data?.timesheet_data);

    let reqData = {
      ...data,
      ...cal,
      timesheet_data: sortedArr,
      type:
        findLeave?.leave_duration == FULL_DAY
          ? 'leave'
          : findLeave?.leave_duration == HALF_DAY
            ? 'semiWorking'
            : data?.type,
      month: month,
      year: year,
      user_id: authState?.id,
      total_hours: Number(data?.total_hours),
      date: dayjsToDateFormat(data.date),
    };

    try {
      const response = isEdit.edit
        ? await TimeSheetApi.update({
            ...reqData,
            id: isEdit?.id,
            userRoleID: authState?.userRoleID,
          })
        : await TimeSheetApi.create({
            ...reqData,
            userRoleID: authState?.userRoleID,
          });
      if (response.data.success) {
        toastSuccess(response.data.message);
        modalClose('changes');
        navigate('/timesheet', { replace: true });
      } else {
        toastWarn(response.data.message);
      }
    } catch (error) {
      //toastError(error.response.data.message);
      toastError(error);
    }
  };

  // Drag and Drop Handler

  const moveElements = (oldIdx, newIdx, arr) => {
    if (arr?.length < 2) return arr;
    let element = arr[oldIdx];
    arr.splice(oldIdx, 1);
    arr.splice(newIdx, 0, element);
    return arr;
  };

  const onDragDropEnds = (oldIndex, newIndex) => {
    if (oldIndex === newIndex) return;

    let newFeildCrtl = moveElements(oldIndex, newIndex, feildCtrl || []);
    setFeildCtrl((pre) => [...newFeildCrtl]);

    let newModuleArrVal = moveElements(
      oldIndex,
      newIndex,
      feildValue.module || [],
    );

    setFeildValue((pre) => ({
      ...pre,
      module: newModuleArrVal,
    }));
    let timeSpent = getFormFeilds('timesheet_data') || [];
    let newTimeSpent = moveElements(oldIndex, newIndex, timeSpent || []);
    setLog((pre) => [...newTimeSpent]);
    if (assignPermission.isApplied) {
      setAssignedPermission((pre) => ({ ...pre, index: newIndex }));
    }
    handleTimeSwap(oldIndex, newIndex);
  };

  const handleTimeSwap = (oldIndex, newIndex) => {
    let timeSpent = getFormFeilds('timesheet_data') || [];
    let AfterSwaped = timeSpent.map((item, index) => {
      if (index >= newIndex) {
        return { ...item, time_spent: [], individual_hours: null };
      }
      return item;
    });
    form.setFieldValue('timesheet_data', AfterSwaped);
    let calculatedSwap = Number(calculateIndivHrs(AfterSwaped) || 0).toFixed(2);
    setFormFeilds('total_hours', calculatedSwap);
  };
  const setNewList = (newlist) => {};

  const resetLogData = async (resetLogs) => {
    if (resetLogs?.type !== 'working') {
      let time_spent = resetLogs?.timesheet_data || [];
      let feildCtrls = [];
      time_spent.forEach((item) => {
        feildCtrls.push(manageFeildCtrls(item));
      });
      setFeildCtrl(feildCtrls);
      setFormFeilds('type', resetLogs?.type);
      watchRef.current = resetLogs?.type;
      form.setFieldValue('timesheet_data', time_spent);
      form.setFieldValue('total_hours', 0);
    } else if (resetLogs?.type === 'working') {
      form.setFieldsValue(initialValues);
    }
  };

  const handleLeaves = async (e) => {
    if (e.target.value === 'working') {
      form.setFieldValue('timesheet_data', log);
      setFeildCtrl([CTRL_CONST]);
      setFeildValue((pre) => ({ ...pre, module: [[]], taskFeild: [] }));
      watchRef.current = 'working';
      disableProject(TASK_FEILDS[2]);
      return;
    }

    let setLabel = confirmLabelSetter(e.target.value) || {};
    confirmationPopup(async (canDelete) => {
      if (canDelete) {
        let resetLogs = await getLeaveConfirmation();
        await resetLogData(resetLogs);
      } else {
        setFormFeilds('type', '');
      }
    }, setLabel);
  };

  const confirmLabelSetter = (value) => {
    let setLabel = {};
    switch (value) {
      case 'weekend':
        setLabel = CONFIRMATIONWEEKEND;
        break;
      case 'publicHoliday':
        setLabel = CONFIRMATIONHOLIDAY;
        break;
      case FULL_DAY:
        setLabel = CONFIRMATIONFULLDAY;
        break;
      default:
        setLabel = {};
        break;
    }
    return setLabel || {};
  };

  const manageFeildCtrls = (item) => ({
    task_type: item?.task_type || false,
    customModule: item?.customModule || false,
    isDeactivated: item?.isDeactivated || false,
    LeaveType: item?.LeaveType || false,
  });

  const limitCrossedTime = (timeSpent, indx) => {
    setFormListFeilds(indx, 'time_spent', [timeSpent[0], CROSSED_TIME]);
    const mintsToRound = convertTimeToOne([timeSpent[0], CROSSED_TIME]);
    const formattedTimeSpent = formatNumber(mintsToRound);
    setFormListFeilds(indx, 'individual_hours', formattedTimeSpent);
  };

  const handleHrs = (e, indx) => {
    let timeSpent = getFormFeilds('timesheet_data') || [];
    let hrsEntered = e?.target?.value;
    setFormListFeilds(indx, 'individual_hours', hrsEntered);
    let newValconverted = Number(hrsEntered / ONE_BY_SIXTY);
    newValconverted = Math.round(newValconverted);
    const preEndTime = timeSpent[indx - 1];
    const current_time_spent = timeSpent[indx];

    if (current_time_spent?.time_spent?.length == 2 && hrsEntered >= 0) {
      let newEndTime = dayjs(current_time_spent?.time_spent[0]).add(
        newValconverted,
        'minutes',
      );
      const timeSpentData = [current_time_spent?.time_spent[0], newEndTime];
      const getSameDate =
        dayjs(current_time_spent?.time_spent[0]).format(DateFormat) ===
        dayjs(newEndTime).format(DateFormat);

      const verifyEntered = verifyEnteredHrs(timeSpentData, indx);
      if (verifyEntered) {
        emptyCrossedTime(indx);
      } else {
        if (getSameDate) {
          setFormListFeilds(indx, 'time_spent', timeSpentData);
        } else {
          limitCrossedTime(timeSpentData, indx);
        }
      }
    } else if (preEndTime?.time_spent?.length == 2 && hrsEntered >= 0) {
      let newEndTime = dayjs(preEndTime?.time_spent[1]).add(
        newValconverted,
        'minutes',
      );
      const timeSpentData = [preEndTime?.time_spent[1], newEndTime];
      const getSameDate =
        dayjs(preEndTime?.time_spent[1]).format(DateFormat) ===
        dayjs(newEndTime).format(DateFormat);
      const verifyEntered = verifyEnteredHrs(timeSpentData, indx);
      if (verifyEntered) {
        emptyCrossedTime(indx);
      } else {
        if (getSameDate) {
          setFormListFeilds(indx, 'time_spent', timeSpentData);
        } else {
          limitCrossedTime(timeSpentData, indx);
        }
      }
    } else if (current_time_spent?.time_spent?.length !== 2 && hrsEntered > 0) {
      toastWarn('Enter Time Spent');
    }
    sumUpTotalHrs();
  };

  const handleChange = (e, index) => {
    let value = e.target.value;
    let inputString = value;

    let sanitized = inputString.replace(/[^0-9.]/g, '');
    const firstDot = sanitized.indexOf('.');
    if (firstDot !== -1) {
      sanitized =
        sanitized.slice(0, firstDot + 1) +
        sanitized.slice(firstDot + 1).replace(/\./g, '');
    }
    if (sanitized.indexOf('.') !== -1) {
      let parts = sanitized.split('.');
      sanitized = `${parts[0]}.${parts[1].slice(0, 2)}`;
    }
    if (parseFloat(sanitized) > 24.0) {
      sanitized = '0';
    }
    if (parseFloat(sanitized) < 0) {
      sanitized = '0';
    }

    let timesheetData = form.getFieldValue('timesheet_data');

    let individualData = form.getFieldValue(['timesheet_data', index]);

    let moduleObject = feildValue?.module[index]?.filter(
      (element) => element?.value == individualData?.module_id,
    );

    let projectData = feildValue?.project?.filter(
      (element) => element?.value == individualData?.project_id,
    );

    var moduleHoursTaken = 0.0;

    var projectHoursTaken = 0.0;

    for (const element of timesheetData) {
      if (element?.module_id == individualData?.module_id) {
        moduleHoursTaken += parseFloat(element?.individual_hours) || 0.0;
      }
      if (element?.project_id == individualData?.project_id) {
        projectHoursTaken += parseFloat(element?.individual_hours) || 0.0;
      }
    }

    let condition = moduleObject[0]?.estimated_hours
      ? parseFloat(moduleHoursTaken) >
        parseFloat(moduleObject[0]?.remainingHours || 0)
      : false;

    if (condition == false && projectData[0]?.estimatedHours) {
      condition =
        parseFloat(projectHoursTaken) >
        parseFloat(projectData[0]?.remainingHours || 0);
    }

    if (condition && ![1, 2, 3, 4].includes(moduleObject[0]?.value)) {
      setFormListFeilds(index, 'time_spent', [
        individualData?.time_spent[0],
        null,
      ]);
      setFormListFeilds(index, 'individual_hours', null);
      toastInfo('The balance hours for this module have been completed.');
      return;
    }

    e.target.value = sanitized;

    handleHrs(e, index);

    return;
  };

  const getLeaveConfirmation = async () => {
    let checkDate = form.getFieldsValue() || {};
    let reqData = {
      date: dayjsToDateFormat(checkDate?.date),
      type: checkDate?.type,
    };
    try {
      let response = await TimeSheetApi.checkHoliday(reqData);
      if (response?.data?.success) {
        toastSuccess(response?.data?.message);
        return response?.data?.result;
      } else {
        toastWarn(response?.data?.message);
      }
    } catch (error) {
      //toastError(error.response.data.message);
      toastError(error);
      return {};
    }
  };

  const handleRemove = (remove, name) => {
    if (watchType !== 'working') {
      toastInfo('Please mark it as ‘working’ to Remove log.');
      return;
    }
    remove(name);
    disableProject(TASK_FEILDS[2]);
    let setCtrlFeild = removevalues(name, feildCtrl);
    setFeildCtrl((pre) => [...setCtrlFeild]);

    let setvalueFeild = removevalues(name, feildValue.module);
    setFeildValue((pre) => ({ ...pre, module: [...setvalueFeild] }));

    sumUpTotalHrs();
  };

  const removevalues = (indx, arr) => {
    arr.splice(indx, 1);
    return arr || [];
  };

  const modalClose = (type = 'nochange') => {
    navigate('/timesheet', { replace: true });
    toggleModal(type);
  };

  const handleCancelCheck = () => {
    let timesheetData = form.getFieldValue('timesheet_data') || [];
    const isDataFilled = timesheetData.some(
      (item) => item?.project_id || item?.module_id || item?.task,
    );

    if (isDataFilled) {
      confirmationPopup(
        (canCancel) => {
          if (canCancel) {
            modalClose();
          }
        },
        {
          title: 'Cancel Confirmation',
          content: 'Are you sure you want to cancel?',
          okText: 'Yes',
          okType: 'primary',
          cancelText: 'No',
        },
      );
    } else {
      modalClose();
    }
  };

  const validateTimeSpent = (rule, value, cb) => {
    let newSetKey = true;
    if (!value?.length) {
      newSetKey = false;
    } else {
      for (let val of value) {
        if (Boolean(val)) {
          newSetKey = true;
        } else {
          newSetKey = false;
          break;
        }
      }
    }

    if (!newSetKey) {
      return Promise.reject(new Error(''));
    } else {
      return Promise.resolve();
    }
  };

  const validateIndiviHr = (rule, value, cb) => {
    if (value === '') {
      return Promise.reject(new Error(''));
    } else {
      return Promise.resolve();
    }
  };

  const resetDate = () => {
    if (['weekend', 'publicHoliday'].includes(watchType)) {
      setFormFeilds('timesheet_data', [
        {
          project_id: null,
          project_name: null,
          module_id: null,
          module_name: null,
          task: null,
          leave_duration: null,
          billable: false,
          time_spent: [],
          type: 'working',
          consider_bill: 'bill',
          individual_hours: null,
        },
      ]);
      setFormFeilds('type', 'working');
      setFeildCtrl([{ ...CTRL_CONST }]);
      setFeildValue((pre) => ({
        project: [...pre.project],
        module: [[]],
        taskFeild: [],
      }));
      setLog([
        {
          project_id: null,
          project_name: null,
          module_id: null,
          module_name: null,
          task: null,
          leave_duration: null,
          billable: false,
          time_spent: SET_START_TIME,
          type: 'working',
          consider_bill: 'bill',
          individual_hours: 1,
        },
      ]);
      sumUpTotalHrs();
    } else if (watchType == 'working') {
      getAppliedPermissionData();
    }
  };

  const calculatebillable = (item) => {
    let bill = 0,
      nonbill = 0;
    item.forEach((itm, indx) => {
      if (itm.billable === true && itm.consider_bill === 'bill') {
        // bill += Number(itm.individual_hours);
        bill += convertTimeToOne(itm?.time_spent);
        return;
      } else if (
        itm.billable === false &&
        itm.consider_bill === 'bill' &&
        itm.project_id !== 1
      ) {
        // nonbill += Number(itm.individual_hours);
        nonbill += convertTimeToOne(itm?.time_spent);
      }
    });
    return {
      total_nonBillable_hours: Number(nonbill.toFixed(2)) || 0,
      total_billable_hours: Number(bill.toFixed(2)) || 0,
    };
  };

  const switchModules = (index) => {
    let newCtrlField = feildCtrl;
    let feildctrlIdx = newCtrlField[index];
    newCtrlField[index] = { ...feildctrlIdx, customModule: false };
    setFormListFeilds(index, 'module_name');
    setFormListFeilds(index, 'module_id');
    setFormListFeilds(index, 'task');
    setFeildCtrl(() => [...newCtrlField]);
  };
  const addCustomModule = (menu, idx) => {
    let projectId = getFormListFeilds(idx, 'project_id') || 0;
    let getModuleCustom =
      feildValue.project.find((item) => item.value === projectId) || {};

    return (
      <>
        {menu}
        {getModuleCustom['customModule'] === true && (
          <>
            <Divider style={{ margin: '8px 0' }} />
            <div className="w-100 text-center">
              <Button
                type="dashed"
                className="w-100"
                icon={<PlusOutlined />}
                onClick={() => addModuleItem(idx)}
              >
                Add Module
              </Button>
            </div>
          </>
        )}
      </>
    );
  };

  const addModuleItem = (idx) => {
    let timesheetData = form.getFieldValue('timesheet_data');

    let individualData = form.getFieldValue(['timesheet_data', idx]);

    let moduleObject = feildValue?.module[idx]?.filter(
      (element) => element?.value == individualData?.module_id,
    );

    let projectData = feildValue?.project?.filter(
      (element) => element?.value == individualData?.project_id,
    );

    var moduleHoursTaken = 0.0;

    var projectHoursTaken = 0.0;

    for (const element of timesheetData) {
      if (element?.module_id == individualData?.module_id) {
        moduleHoursTaken += parseFloat(element?.individual_hours) || 0.0;
      }
      if (element?.project_id == individualData?.project_id) {
        projectHoursTaken += parseFloat(element?.individual_hours) || 0.0;
      }
    }

    let condition = moduleObject[0]?.estimated_hours
      ? parseFloat(moduleHoursTaken) >
        parseFloat(moduleObject[0]?.remainingHours || 0)
      : false;

    if (condition == false && projectData[0]?.estimatedHours) {
      condition =
        parseFloat(projectHoursTaken) >
        parseFloat(projectData[0]?.remainingHours || 0);
    }

    if (condition && ![1, 2, 3, 4].includes(moduleObject[0]?.value)) {
      setFormListFeilds(idx, 'time_spent', [
        individualData?.time_spent[0],
        null,
      ]);
      setFormListFeilds(idx, 'individual_hours', null);
      toastInfo('The balance hours for this module have been completed.');
      return;
    }

    let newCtrlField = feildCtrl;
    let feildctrlIdx = newCtrlField[idx];
    newCtrlField[idx] = { ...feildctrlIdx, customModule: true };
    setFormListFeilds(idx, 'module_id');
    setFormListFeilds(idx, 'task');
    setFormListFeilds(idx, 'module_name');
    setFeildCtrl((pre) => [...newCtrlField]);
  };

  return (
    <>
      <div>
        <Form
          initialValues={initialValues}
          form={form}
          onFinish={onSubmit}
          layout="vertical"
        >
          <div className="row mx-0 align-items-start align-items-md-center mb-3 p-0">
            <div className="col-auto text-nowrap fs-5 fw-semibold ps-0 order-1">
              {isEdit?.title} Time Log
            </div>
            <div className="col-lg-auto mt-2 m-md-0 p-0 order-3 order-lg-2">
              <Form.Item
                name={'date'}
                style={{ marginBottom: 0 }}
                rules={[{ required: true, message: '' }]}
              >
                <DatePicker
                  inputReadOnly={true}
                  // format={DateFormat}
                  format={DisplayDateFormat}
                  onChange={resetDate}
                  maxDate={dayjs()}
                  locale={'en-in'}
                />
              </Form.Item>
            </div>
            <div className="col-lg-auto mt-2 m-md-0 p-0 order-4 order-lg-3">
              <Form.Item
                name="type"
                style={{ marginBottom: 0, marginLeft: 8 }}
                // rules={[{ required: true, message: "" }]}
              >
                <Radio.Group onChange={handleLeaves}>
                  <Radio value="working">Working</Radio>
                  <Radio value="weekend">Weekend</Radio>
                  <Radio value="publicHoliday">Public Holiday</Radio>
                </Radio.Group>
              </Form.Item>
            </div>
            <div className="col-auto px-0 text-end order-2 order-lg-4 ms-auto">
              <Button
                className="p-0"
                icon={<CloseOutlined />}
                onClick={handleCancelCheck}
              ></Button>
            </div>
          </div>

          {/* <div class="row mx-0 align-items-start align-items-md-center mb-3 p-0">
            <div class="col-auto border order-2">Column 1</div>
            <div class="col-auto border order-1">Column 2</div>
            <div class="col-auto border order-3">Column 3</div>
          </div> */}

          <div className={style.addLogTable}>
            <Table responsive borderless className="" style={{ minWidth: 850 }}>
              <thead>
                <tr>
                  {columns.map((item, index) => (
                    <th key={index}>
                      {item.headerName}
                      {item?.required ? <Mandatory /> : ''}
                    </th>
                  ))}
                </tr>
              </thead>

              <ReactSortable
                tag={'tbody'}
                list={log}
                setList={(newlist) => setNewList(newlist)}
                ghostClass="dropArea"
                handle=".dragHandle"
                filter=".ignoreDrag"
                preventOnFilter={true}
                className="grid-container"
                onEnd={({ oldIndex, newIndex }) =>
                  onDragDropEnds(oldIndex, newIndex)
                }
              >
                <Form.List name="timesheet_data">
                  {(fields, { add, remove }) => (
                    <>
                      {fields.map(({ key, name, ...restField }, index) => (
                        <tr key={key}>
                          <td className="col-auto dragHandle">
                            <span style={{ cursor: 'move' }}>
                              <RxDragHandleDots2 size={18} />
                            </span>
                          </td>
                          <td className="col-2 p-1">
                            {feildCtrl[index]?.isDeactivated && (
                              <Form.Item
                                name={[name, 'project_name']}
                                style={{ marginBottom: 0 }}
                              >
                                <Input
                                  readOnly
                                  disabled
                                  placeholder="Enter Project"
                                />
                              </Form.Item>
                            )}
                            {!feildCtrl[index]?.isDeactivated && (
                              <Form.Item
                                name={[name, 'project_id']}
                                style={{ marginBottom: 0 }}
                                rules={[{ required: true, message: '' }]}
                              >
                                <Select
                                  type="select"
                                  optionFilterProp="label"
                                  placeholder="Select Project"
                                  optionLabelProp="label"
                                  showSearch
                                  onChange={(e) => getModuleDropDown(e, index)}
                                >
                                  {feildValue?.project?.map((element) => (
                                    <Option
                                      key={element.value}
                                      value={element.value}
                                      label={element.label}
                                      disabled={
                                        element?.isDisabled ? true : false
                                      }
                                    >
                                      <div>
                                        <div
                                          className="text-wrap"
                                          style={{
                                            fontWeight: 'bold',
                                          }}
                                        >
                                          {element.label}
                                        </div>
                                        <div
                                          style={{
                                            color: '#999',
                                          }}
                                        >
                                          {element?.customer_name}
                                        </div>
                                      </div>
                                    </Option>
                                  ))}
                                </Select>
                                {/* <Select
                                  options={feildValue.project} //safik
                                  type="select"
                                  optionFilterProp="label"
                                  placeholder="Select Project"
                                  showSearch
                                  onChange={(e) => getModuleDropDown(e, index)}
                                /> */}
                              </Form.Item>
                            )}
                          </td>
                          <td className="col-2 p-1">
                            {feildCtrl[index]?.isDeactivated && (
                              <Form.Item
                                name={[name, 'module_name']}
                                style={{ marginBottom: 0 }}
                              >
                                <Input
                                  readOnly
                                  disabled={true}
                                  placeholder="Enter Module"
                                />
                              </Form.Item>
                            )}
                            {!feildCtrl[index]?.customModule &&
                              !feildCtrl[index]?.isDeactivated && (
                                <Form.Item
                                  name={[name, 'module_id']}
                                  style={{ marginBottom: 0 }}
                                  rules={[{ required: true, message: '' }]}
                                >
                                  <Select
                                    type="select"
                                    dropdownRender={(menu) =>
                                      addCustomModule(menu, index)
                                    }
                                    optionFilterProp="label"
                                    placeholder="Select Module"
                                    showSearch
                                    onChange={(value, option) => {
                                      // User explicitly picked a module — release force-open lock
                                      moduleSelectForceOpen.current[index] =
                                        false;
                                      setModuleSelectOpen((prev) => {
                                        const n = { ...prev };
                                        delete n[index];
                                        return n;
                                      });
                                      setPopoverVisible({});
                                      handleTaskFeild(index, 0, option);
                                    }}
                                    optionLabelProp="label"
                                    // Controlled open prop — keeps Select open while three-dot popup is shown
                                    open={moduleSelectOpen[index]}
                                    onDropdownVisibleChange={(open) => {
                                      if (
                                        !open &&
                                        moduleSelectForceOpen.current[index]
                                      ) {
                                        // Ant Design fired a close signal, but the three-dot popup is active.
                                        // Re-assert open state immediately so the dropdown stays visible.
                                        setModuleSelectOpen((prev) => ({
                                          ...prev,
                                          [index]: true,
                                        }));
                                        return; // do NOT clear popoverVisible
                                      }
                                      // Normal open / close
                                      moduleSelectForceOpen.current[index] =
                                        false;
                                      setModuleSelectOpen((prev) => ({
                                        ...prev,
                                        [index]: open,
                                      }));
                                      if (!open) setPopoverVisible({});
                                    }}
                                  >
                                    {(feildValue.module[index] || []).map(
                                      (mod) => {
                                        // isPrimary is read directly from the module data returned
                                        // by the API (primary: true/false). This works across
                                        // logins because we never rely on a transient state map.
                                        const isPrimary = !!mod.primary;
                                        const popKey = `${index}_${mod.value}`;
                                        return (
                                          <Select.Option
                                            key={mod.value}
                                            value={mod.value}
                                            label={mod.label}
                                            estimated_hours={
                                              mod.estimated_hours
                                            }
                                            remainingHours={mod.remainingHours}
                                            project_id={mod.project_id}
                                          >
                                            <div
                                              style={{
                                                display: 'flex',
                                                alignItems: 'center',
                                                justifyContent: 'space-between',
                                                width: '100%',
                                                gap: 4,
                                              }}
                                            >
                                              <span
                                                style={{
                                                  flex: 1,
                                                  overflow: 'hidden',
                                                  textOverflow: 'ellipsis',
                                                  whiteSpace: 'nowrap',
                                                }}
                                              >
                                                {mod.label}
                                              </span>

                                              {isPrimary ? (
                                                /* Green tick — primary module */
                                                <CheckCircleFilled
                                                  style={{
                                                    color: '#52c41a',
                                                    fontSize: 15,
                                                    flexShrink: 0,
                                                  }}
                                                  title="Default Module"
                                                />
                                              ) : (
                                                /* Three-dot + controlled popup */
                                                <Popover
                                                  open={
                                                    !!popoverVisible[popKey]
                                                  }
                                                  /* We control open/close manually — no auto trigger */
                                                  trigger={[]}
                                                  placement="right"
                                                  /* Render popup in body so it is above the Select dropdown overlay */
                                                  getPopupContainer={() =>
                                                    document.body
                                                  }
                                                  overlayInnerStyle={{
                                                    padding: '2px 0',
                                                  }}
                                                  content={
                                                    <div
                                                      style={{ minWidth: 150 }}
                                                    >
                                                      <div
                                                        style={{
                                                          padding: '7px 14px',
                                                          cursor: 'pointer',
                                                          fontSize: 13,
                                                          display: 'flex',
                                                          alignItems: 'center',
                                                          gap: 7,
                                                          borderRadius: 4,
                                                        }}
                                                        onMouseEnter={(e) =>
                                                          (e.currentTarget.style.background =
                                                            '#f0fdf4')
                                                        }
                                                        onMouseLeave={(e) =>
                                                          (e.currentTarget.style.background =
                                                            'transparent')
                                                        }
                                                        onClick={(e) => {
                                                          e.preventDefault();
                                                          e.stopPropagation();
                                                          setPopoverVisible({}); // ✅ add this line
                                                          // Release force-open lock BEFORE handleSetPrimary
                                                          moduleSelectForceOpen.current[
                                                            index
                                                          ] = false;
                                                          const pid =
                                                            getFormListFeilds(
                                                              index,
                                                              'project_id',
                                                            );
                                                          handleSetPrimary(
                                                            pid,
                                                            mod.value,
                                                            index,
                                                          );
                                                        }}
                                                      >
                                                        <CheckCircleFilled
                                                          style={{
                                                            color: '#52c41a',
                                                            fontSize: 14,
                                                          }}
                                                        />
                                                        Set as Default
                                                      </div>
                                                    </div>
                                                  }
                                                >
                                                  {/* Three-dot icon — use onMouseDown to beat Select's click handler */}
                                                  <span
                                                    style={{
                                                      display: 'inline-flex',
                                                      alignItems: 'center',
                                                      justifyContent: 'center',
                                                      width: 22,
                                                      height: 22,
                                                      borderRadius: 4,
                                                      flexShrink: 0,
                                                      cursor: 'pointer',
                                                      color: '#8c8c8c',
                                                    }}
                                                    onMouseEnter={(e) =>
                                                      (e.currentTarget.style.background =
                                                        '#f0f0f0')
                                                    }
                                                    onMouseLeave={(e) =>
                                                      (e.currentTarget.style.background =
                                                        'transparent')
                                                    }
                                                    onClick={(e) => {
                                                      e.preventDefault();
                                                      e.stopPropagation();

                                                      // Toggle popover visibility
                                                      setPopoverVisible(
                                                        (prev) => {
                                                          const isOpen =
                                                            !!prev[popKey];
                                                          return {
                                                            [popKey]: !isOpen,
                                                          };
                                                        },
                                                      );

                                                      // If opening popover, keep dropdown open
                                                      if (
                                                        !popoverVisible[popKey]
                                                      ) {
                                                        moduleSelectForceOpen.current[
                                                          index
                                                        ] = true;
                                                        setModuleSelectOpen(
                                                          (prev) => ({
                                                            ...prev,
                                                            [index]: true,
                                                          }),
                                                        );
                                                      } else {
                                                        moduleSelectForceOpen.current[
                                                          index
                                                        ] = false;
                                                      }
                                                    }}
                                                  >
                                                    <MoreOutlined
                                                      style={{ fontSize: 16 }}
                                                    />
                                                  </span>
                                                </Popover>
                                              )}
                                            </div>
                                          </Select.Option>
                                        );
                                      },
                                    )}
                                  </Select>
                                </Form.Item>
                              )}
                            {!feildCtrl[index]?.isDeactivated &&
                              feildCtrl[index]?.customModule && (
                                <Form.Item
                                  name={[name, 'module_name']}
                                  style={{ marginBottom: 0 }}
                                  rules={[{ required: true, message: '' }]}
                                >
                                  <Input
                                    maxLength={150}
                                    addonAfter={
                                      <IoIosSwitch
                                        className="tmPointer"
                                        title="Switch to Select"
                                        onClick={() => switchModules(index)}
                                      />
                                    }
                                    placeholder="Module Name"
                                    onChange={(e) => {
                                      setFormListFeilds(
                                        index,
                                        'module_name',
                                        e?.target?.value?.replace(/^\s+/, '') ??
                                          '',
                                      );
                                    }}
                                  />
                                </Form.Item>
                              )}
                          </td>
                          <td className="col-4 p-1">
                            {feildCtrl[index]?.LeaveType && (
                              <div className="d-flex justify-content-between">
                                <Form.Item
                                  name={[name, 'leave_duration']}
                                  style={{
                                    marginBottom: 0,
                                    width: '50%',
                                    marginRight: 8,
                                  }}
                                  rules={[{ required: true, message: '' }]}
                                >
                                  {feildCtrl[index]?.task_type && (
                                    <Select
                                      onChange={(e) => changeLogType(e, index)}
                                      options={LEAVE_DURATION}
                                      type="select"
                                      disabled={
                                        !!feildCtrl[index]?.isDeactivated
                                      }
                                      placeholder="Leave Duration"
                                      showSearch
                                    />
                                  )}
                                </Form.Item>
                                <Form.Item
                                  name={[name, 'task']}
                                  style={{ marginBottom: 0, width: '50%' }}
                                  rules={[{ required: true, message: '' }]}
                                >
                                  {feildCtrl[index]?.task_type && (
                                    <Select
                                      // onChange={(e) => inculdeForCalc(e, index)}
                                      options={feildValue.taskFeild[index]}
                                      type="select"
                                      placeholder="Leave Type"
                                      showSearch
                                    />
                                  )}
                                </Form.Item>
                              </div>
                            )}
                            {!feildCtrl[index]?.LeaveType && (
                              <Form.Item
                                name={[name, 'task']}
                                style={{ marginBottom: 0 }}
                                rules={[{ required: true, message: '' }]}
                              >
                                {!feildCtrl[index]?.task_type && (
                                  <TextArea
                                    rows={1}
                                    disabled={
                                      watchType !== 'working' &&
                                      !!feildCtrl[index]?.isDeactivated
                                    }
                                    onChange={(e) => {
                                      setFormListFeilds(
                                        index,
                                        'task',
                                        e?.target?.value?.replace(/^\s+/, '') ??
                                          '',
                                      );
                                    }}
                                    placeholder="Enter the task"
                                  />
                                )}
                                {feildCtrl[index]?.task_type && (
                                  <Select
                                    // onChange={(e) => inculdeForCalc(e, index)}
                                    options={feildValue.taskFeild[index]}
                                    type="select"
                                    disabled={!!feildCtrl[index]?.isDeactivated}
                                    placeholder="Select Task"
                                    showSearch
                                  />
                                )}
                              </Form.Item>
                            )}
                          </td>

                          <td className="col-3 p-1">
                            {watchType === 'working' && (
                              <Form.Item
                                name={[name, 'time_spent']}
                                style={{ marginBottom: 0 }}
                                rules={[
                                  {
                                    required: true,
                                    message: '',
                                    validator: validateTimeSpent,
                                  },
                                ]}
                              >
                                <TimePicker.RangePicker
                                  format="h:mm A"
                                  allowClear={false}
                                  onChange={(e) => handleTimeSpent(e, index)}
                                  style={{
                                    marginBottom: 0,
                                    width: '100%',
                                  }}
                                  autoFocus
                                  needConfirm={false}
                                />
                              </Form.Item>
                            )}
                            {!(watchType === 'working') && (
                              <Form.Item
                                name={[name, 'time_spents']}
                                style={{ marginBottom: 0 }}
                              >
                                <TimePicker.RangePicker
                                  format="h:mm A"
                                  allowClear={false}
                                  allowEmpty
                                  disabled={true}
                                  style={{
                                    marginBottom: 0,
                                    width: '100%',
                                  }}
                                />
                              </Form.Item>
                            )}
                          </td>

                          <td className="col-1 p-1">
                            <Form.Item
                              name={[name, 'individual_hours']}
                              style={{ marginBottom: 0 }}
                              rules={[
                                {
                                  required:
                                    watchType == 'working' ? true : false,
                                  message: '',
                                  validator: validateIndiviHr,
                                },
                              ]}
                            >
                              <Input
                                // type="number"
                                // step={0.01}
                                disabled={!(watchType === 'working')}
                                // step={0.016666666666}
                                className={`text-end ${style.antdNum}`}
                                min={0}
                                max={23.99}
                                placeholder="Hrs"
                                onChange={(value) => handleChange(value, index)}
                              />
                            </Form.Item>
                          </td>

                          <td
                            className="col-auto p-1 text-center align-middle"
                            style={{ minWidth: '30px' }}
                          >
                            <FaRegCircleXmark
                              className="text-danger tmPointer"
                              onClick={() => handleRemove(remove, name)}
                              size={16}
                            />
                          </td>
                        </tr>
                      ))}
                    </>
                  )}
                </Form.List>
                <>
                  {assignPermission?.isApplied && (
                    <tr>
                      <td>&nbsp;</td>
                      <td className="py-0 px-1">
                        <span
                          className="d-inline-block border w-100 p-1 rounded-1 px-2"
                          style={{
                            backgroundColor: '#f5f5f5',
                            color: '#d0d0d0',
                          }}
                        >
                          {assignPermission?.log.project_name}
                        </span>
                      </td>
                      <td className="py-0 px-1">
                        <span
                          className="d-inline-block border w-100 p-1 rounded-1 px-2"
                          style={{
                            backgroundColor: '#f5f5f5',
                            color: '#d0d0d0',
                          }}
                        >
                          {assignPermission?.log.module_name}
                        </span>
                      </td>
                      <td className="py-0 px-1">
                        <span
                          className="d-inline-block border w-100 p-1 rounded-1 px-2"
                          style={{
                            backgroundColor: '#f5f5f5',
                            color: '#d0d0d0',
                          }}
                        >
                          {assignPermission?.log.task}
                        </span>
                      </td>
                      <td className="py-0 px-1">
                        {/* <span
                          className="d-inline-block border w-100 p-1 rounded-1 px-2"
                          style={{
                            backgroundColor: '#f5f5f5',
                            color: '#d0d0d0',
                          }}
                        >
                          {assignPermission?.log.task}
                        </span> */}
                        <TimePicker.RangePicker
                          format="h:mm A"
                          allowClear={false}
                          allowEmpty
                          disabled={true}
                          value={assignPermission?.log.time_spent}
                          style={{
                            marginBottom: 0,
                            width: '100%',
                          }}
                        />
                      </td>
                      <td className="py-0 px-1">
                        <span
                          className="d-inline-block border w-100 p-1 rounded-1 px-2 pe-2 text-end "
                          style={{
                            backgroundColor: '#f5f5f5',
                            color: '#d0d0d0',
                          }}
                        >
                          {assignPermission?.log.individual_hours}&nbsp;
                        </span>
                      </td>

                      <td>&nbsp;</td>
                    </tr>
                  )}
                </>
                <tr>
                  <td colSpan={100} className="p-1">
                    <div className="d-flex justify-content-between align-items-center p-0">
                      <div className="col-5">
                        <Form.Item style={{ marginBottom: 0 }}>
                          <Button
                            type="dashed"
                            htmlType="button"
                            onClick={() => handleAdd('add')}
                            icon={<PlusOutlined />}
                          >
                            Add Log
                          </Button>
                        </Form.Item>
                      </div>
                      <div className="col-3">
                        <b>
                          <div
                            className="d-flex align-items-center justify-content-between header_bgcolor "
                            style={{ height: '35px' }}
                          >
                            <span className="px-1 ps-2">
                              Total Hours &nbsp; :
                            </span>
                            <span className="px-1 pe-2 me-4">
                              <Form.Item
                                name={'total_hours'}
                                style={{
                                  marginBottom: 0,
                                  border: 0,
                                  maxWidth: 150,
                                }}
                              >
                                <Input
                                  variant="borderless"
                                  readOnly
                                  className={`text-end fw-bold fs-5`}
                                  min={0}
                                  onFocus={(e) => e.preventDefault()}
                                  placeholder="Hrs"
                                />
                              </Form.Item>
                            </span>
                          </div>
                        </b>
                      </div>
                    </div>
                  </td>
                </tr>
              </ReactSortable>
            </Table>
          </div>
          <div className="text-end mt-3">
            <span className="supported_text">
              <Dropdown
                key={'twodd'}
                menu={{ items }}
                placement="topLeft"
                arrow
              >
                <button className="btn m-0 p-0 border-none" type="button">
                  <IoMdInformationCircleOutline size={16} />
                  <small>&nbsp;Conversion Formats</small>
                </button>
              </Dropdown>
            </span>
          </div>
          <div className="antdBtn text-center">
            <Button
              type="default"
              htmlType="button"
              onClick={handleCancelCheck}
            >
              Cancel
            </Button>
            <Button type="primary" htmlType="submit">
              {isEdit.edit ? 'Update' : 'Save'}
            </Button>
          </div>
        </Form>
      </div>
    </>
  );
};

export default AddLogBdyDnD;
